





















import { Component, Vue } from 'vue-property-decorator';
import JobTake5Form from '@/components/jobSafetyTake5/Take5Safety.vue';
import * as JobsAPI from '@/api/jobsApi';
import Nullable from '@/types/nullable';
import { JobTake5Check } from '@/models/jobTake5/jobTake5Check';

@Component({
  components: {
    JobTake5Form
  }
})
export default class ViewJobTake5Safety extends Vue {
  private loading: boolean = false;
  private errorMessage: string = null;
  private jobTake5Check: Nullable<JobTake5Check> = null;
  
  created() {
    this.init();
  }

  handleDataChanged(){
    this.init();
  }

  async init(){
    this.loading = true;

    try {
      this.jobTake5Check = await JobsAPI.getTake5Form(this.$route.params.jobID);
    } catch (err){
      this.errorMessage = err;
    }

    this.loading = false;
  }
}

